import React from 'react';
import { TextField } from '@mui/material';

const CitationFilter = ({ value, onChange }) => {
  return (
    <TextField
      fullWidth
      label="Minimum Citations"
      type="number"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="e.g., 100"
      InputProps={{
        inputProps: { min: 0 }
      }}
    />
  );
};

export default CitationFilter; 